import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { evEditAddressClick } from 'events/account';

import MartyLink from 'components/common/MartyLink';
import DeleteOverlay from 'components/account/InfoCard/DeleteOverlay';
import { track } from 'apis/amethyst';
import css from 'styles/components/account/infoCard/infoCard.scss';

class ShippingAddressCard extends Component {
  state = {
    showConfirmation: false
  };

  onDeleteClick = () => {
    const { onDelete, address } = this.props;
    onDelete(address);
  };

  onEditAddress = ({ currentTarget }) => {
    track(evEditAddressClick, {
      addressType: 2, // amethyst addressType 2 => shipping
      addressIndex: +currentTarget.getAttribute('data-address-index'),
      addressId: currentTarget.getAttribute('data-address-id')
    });
  };

  onMakePrimaryClick = () => {
    const { onPrimary, address } = this.props;
    onPrimary(address);
  };

  hideDeleteConfirmation = () => {
    this.setState({ showConfirmation: false });
  };

  makeDeleteOverlay = () => {
    const { showConfirmation } = this.state;
    return showConfirmation && <DeleteOverlay
      cardInfoText="address"
      hideDeleteConfirmation={this.hideDeleteConfirmation}
      onDeleteClick={this.onDeleteClick} />;
  };

  showDeleteConfirmation = () => {
    this.setState({ showConfirmation: true });
  };

  render() {
    const { testId } = this.context;
    const {
      addressIndex,
      address: {
        addressId,
        isDefaultShippingAddress,
        mailingAddress,
        name: { fullName }
      }
    } = this.props;
    const {
      addressLine1,
      addressLine2,
      districtOrCounty,
      city,
      stateOrRegion,
      postalCode,
      countryName
    } = mailingAddress;

    const ariaCardId = `aria-addressCard-${addressId}`;

    return (
      <li className={cn(css.card, { [css.defaultCard]: isDefaultShippingAddress })} data-test-id={testId('addressCard')}>
        <div id={ariaCardId} className={css.cardDetails}>
          <div data-test-id={testId('addressCardFullName')}>{fullName}</div>
          <div data-test-id={testId('addressCardAddress1')}>{addressLine1}</div>
          <div data-test-id={testId('addressCardAddress2')}>{addressLine2}</div>
          <div data-test-id={testId('addressCardDistrict')}>{districtOrCounty}</div>
          <div data-test-id={testId('addressCardCityStateZip')}>{city}, {stateOrRegion} {postalCode}</div>
          <div data-test-id={testId('addressCardCountry')}>{countryName}</div>
        </div>
        <div className={css.cardActions}>
          <div>
            <MartyLink
              to={`/addresses/${addressId}/edit`}
              onClick={this.onEditAddress}
              data-address-id={addressId}
              data-address-index={addressIndex}
              data-test-id={testId('editAddress')}
              aria-describedby={ariaCardId}>Edit</MartyLink>
            <span className={css.separator}>|</span>
            <button
              type="button"
              onClick={this.showDeleteConfirmation}
              data-test-id={testId('deleteAddress')}
              aria-describedby={ariaCardId}>
              Delete
            </button>

            {!isDefaultShippingAddress && (
              <>
                <span className={css.separator}>|</span>
                <button
                  type="button"
                  onClick={this.onMakePrimaryClick}
                  aria-describedby={ariaCardId}
                  data-test-id={testId('setAsPrimary')}>
                  Set as Primary
                </button>
              </>
            )}
          </div>
        </div>
        {this.makeDeleteOverlay()}
      </li>
    );
  }
}

ShippingAddressCard.propTypes = {
  address: PropTypes.object.isRequired,
  onPrimary: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

ShippingAddressCard.contextTypes = {
  testId: PropTypes.func
};

export default ShippingAddressCard;
